import { clone, cloneDeep } from 'lodash';
import ReactDomServer from 'react-dom/server';

import moment from 'moment';
import { AppConstants } from '../../constants/AppConstants';
import { createSignedURL, uploadFile } from '../../http/asset-management-services';
import { HTTP_STATUS } from '../../http/constants/http.status';

import {
  NotificationTemplate,
  createNotificationTemplate,
  getNotificationTemplatesForOrg,
  getNotificationTemplates
} from '../../http/notification-services';

import { getGlobalBucketName } from '../../util/AppSetting';

export const appendDateTimeStamp = (name: string) => {
  return `${name}_copy_${moment().format('YYYYMMDDHHMMSS')}`;
};

export const templateCopy = async (data: any, templateName: any) => {
  let { data: templateData } = cloneDeep(data);
  const { channel: channel1, params, category } = templateData;
  //templateData.category = appendDateTimeStamp(category);
  templateData.category = templateName;
  params.forEach((param: any) => {
    param.channel = channel1;
    delete param.id;
  });
  delete templateData.id;

  const templateResponse = await createNotificationTemplate(templateData);
  const { status, data: templateResponseData } = templateResponse;
  // if (status == HTTP_STATUS.HTTP_CREATED) {
  //   return templateResponseData[0].id;
  // } else {
  //   return templateResponse;
  // }
  return templateResponse;
};
